export default __webpack_public_path__ + "static/media/CI1.704e1c55.png";